import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import { sidebarMenuData, sidebarMenuData2 } from "../Utils/constants";
import { isEmpty, toLower } from "lodash";
import { useNavigate } from "react-router-dom";
import FlagIcon from "../assets/imagesNew/india-icon.webp";
import FlagIconBn from "../assets/imagesNew/bangladesh-flag-round-circle-icon.webp";
import PromotionsIcon from "../assets/images/icon-promotion.webp";
import iconAffiliate from "../assets/images/icon-affiliate.webp";
import HomeIcon from "../assets/images/icon-home.webp";
import iconTalk from "../assets/images/icon-member-talk.svg";
import iconTelegram from "../assets/images/icon-telegram.svg";
import iconAbous from "../assets/images/icon-abous-us.svg";
import iconFaq from "../assets/images/icon-faq.svg";
import { RxCross2 } from "react-icons/rx";
import iconreferral from "../assets/images/icon-referral.webp";

const MenuSidebarNew = () => {
  const logoutUser = useContextSelector(AuthContext, (ctx) => ctx.logoutUser);
  const setShowSidebar = useContextSelector(
    AuthContext,
    (ctx) => ctx.setShowSidebar,
  );

  const handleShowLanguage = useContextSelector(
    AuthContext,
    (ctx) => ctx.handleShowLanguage,
  );
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const setEn = useContextSelector(AuthContext, (ctx) => ctx.setEn);
  const setBr = useContextSelector(AuthContext, (ctx) => ctx.setBr);
  const launchEGTCasino = useContextSelector(
    AuthContext,
    (ctx) => ctx.launchEGTCasino,
  );
  const launchCasino = useContextSelector(
    AuthContext,
    (ctx) => ctx.launchCasino,
  );
  const withoutLogin = useContextSelector(
    AuthContext,
    (ctx) => ctx.withoutLogin,
  );
  const downloadBar = useContextSelector(AuthContext, (ctx) => ctx.downloadBar);
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [activeClass, SetActiveClass] = useState("");
  const [key, setKey] = useState("");
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 180) {
        SetActiveClass("gamefixed");
      } else {
        SetActiveClass("");
      }
    });
  }, []);
  const { t } = useTranslation();
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setShowSidebar(false);
      }}
    >
      <div>
        <div className={downloadBar ? "sidebar-wrapper" : "sidebar-wrapper"}>
          {/* <ul>
            <li>
              <figure>
                {" "}
                <img src={HomeIcon} alt="" />
              </figure>
              <Link to="/" className="text-decoration-none">
                {" "}
                <span>{"Home"}</span>
              </Link>
            </li>
            <button
              className="border-0 p-0"
              onClick={() => setShowSidebar(false)}
            >
              <RxCross2 />
            </button>
          </ul> */}
          <div className="sidebar-cont">
            <ul>
              {sidebarMenuData?.map((item, index) => {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      let gameType = toLower(item?.type);
                      let gameSubType = item?.subCategory
                        ? item?.subCategory
                        : "";
                      navigate(
                        "/casino?header=" +
                          gameType +
                          "&subCasino=" +
                          gameSubType,
                      );
                    }}
                    className={`${key == item?.type ? "active" : ""}`}
                  >
                    {item?.icons == "#language" ? (
                      <img src={"/assets/images/BDT_new.svg"} />
                    ) : (
                      <svg className="am-icon am-icon-nav-hot_0b8ae9aa am-icon-md game-menu-icon">
                        <use xlinkHref={item?.icons}></use>
                      </svg>
                    )}
                    <a className="text-decoration-none">
                      {" "}
                      <span>{lang == "bn" ? item?.titlebn || item?.title : item?.title}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
            <ul>
              {sidebarMenuData2?.map((item, index) => {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      {
                        if (item?.icons == "#language") {
                          handleShowLanguage();
                        } else {
                          isEmpty(user)
                            ? navigate("/login")
                            : navigate(item?.link);
                        }
                      }
                    }}
                    className={`${key == item?.type ? "active" : ""}`}
                  >
                    {item?.icons == "#language" ? (
                      <img src={"/assets/images/BDT_new.svg"} />
                    ) : (
                      <svg className="am-icon am-icon-nav-hot_0b8ae9aa am-icon-md game-menu-icon">
                        <use xlinkHref={item?.icons}></use>
                      </svg>
                    )}
                    <a className="text-decoration-none">
                      {" "}
                      <span>{lang == "bn" ? item?.titlebn || item?.title : item?.title}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* <ul>
            {!isEmpty(user) ? (
              <>
                <li className="language-select">
                  <div
                    className="language-select-div"
                    onClick={() => {
                      setBr();
                    }}
                  >
                    <img src={FlagIconBn} alt="" /> <p>বাংলা</p>
                  </div>
                  <div
                    className="language-select-div"
                    onClick={() => {
                      setEn();
                    }}
                  >
                    <img src={FlagIcon} alt="" /> <p>English</p>
                  </div>
                </li>
              </>
            ) : (
              ""
            )}
          </ul> */}
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default MenuSidebarNew;
